import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Attach access token if we have one saved (in-memory fallback)
let cachedToken = null;

export const setAuthToken = (token) => {
  cachedToken = token;
  if (token) {
    localStorage.setItem("cap_token", token);
    api.defaults.headers.common["Authorization"] = `Bearer ${token}`;
  } else {
    localStorage.removeItem("cap_token");
    delete api.defaults.headers.common["Authorization"];
  }
};

export const getAuthToken = () => {
  if (cachedToken) return cachedToken;
  const stored = localStorage.getItem("cap_token");
  if (stored) {
    cachedToken = stored;
    api.defaults.headers.common["Authorization"] = `Bearer ${stored}`;
  }
  return cachedToken;
};

// Initialize on load
getAuthToken();

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
